module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="paypal-wrapper">\n  <div class="boxColumn check selected">\n    <div class="details">\n      <div class="boxColumn-title"><i class="fa fa-envelope"></i> Mail check to:</div>\n      <div class="address">' +
((__t = (firstName)) == null ? '' : __t) +
' ' +
((__t = (lastName)) == null ? '' : __t) +
'</div>\n      <div class="address">' +
((__t = (street)) == null ? '' : __t) +
'</div>\n      <div class="address">' +
((__t = (city)) == null ? '' : __t) +
'</div>\n      <div class="state">' +
((__t = (state)) == null ? '' : __t) +
' ' +
((__t = (zip)) == null ? '' : __t) +
'</div>\n      <div class="email"><i class="fa fa-at"></i> ' +
((__t = (email)) == null ? '' : __t) +
'</div>\n      <div class="address"><i class="fa fa-phone"></i> ' +
((__t = (phone)) == null ? '' : __t) +
'</div>\n    </div>\n    <button name="check" class="btn-select blue">Selected</button>\n    <div class="check-mark"><i class="fa fa-check"></i></div>\n  </div>\n\n  <div class="or">OR</div>\n\n  <div class="boxColumn paypal">\n    <div class="details paypal">\n      <div class="boxColumn-title"><i class="fa fa-paypal"></i> Paypal transfer to:</div>\n      <div class="paypal"><i class="fa fa-paypal"></i></div>\n      <div class="email">' +
((__t = (paypalAccount)) == null ? '' : __t) +
'</div>\n    </div>\n    <button name="paypal" class="btn-select blue">Select</button>\n    <div class="check-mark"><i class="fa fa-check"></i></div>\n  </div>\n</div>';

}
return __p
}